export const validation = {
  labelMaxChar: 30,
  copyrightMaxChar: 50,
  socials: {
    min: 0,
    max: 7
  }
}
